import { MetadataMap } from "./metadata-map";
import { getEntityPrototypeChain } from "./utils";
const META_PROPERTIES_MAP = new MetadataMap();
export function meta(options) {
    const opts = options || {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (target, key) => {
        META_PROPERTIES_MAP.setMetadataByType(target.constructor, key, Object.assign({
            name: key,
        }, opts));
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export function getMetaMetadata(target) {
    return getEntityPrototypeChain(target).reduce((soFar, prototype) => Object.assign(soFar, META_PROPERTIES_MAP.getMetadataByType(prototype)), {});
}
